export default "__VITE_ASSET__u9QoSlI$__"